var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaison(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_1423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.35 118.918C219.2 138.358 219.06 157.798 218.94 177.228C187.79 195.208 156.61 213.198 125.46 231.178V161.188C156.74 147.108 188.03 133.018 219.35 118.918Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7598 105.078V182.248L125.48 231.178V161.208L79.1198 79.7585L32.7598 105.078Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6299 96.8784C21.3399 99.6085 27.0399 102.358 32.7599 105.088L79.1199 79.7685C99.8799 109.778 120.63 139.768 141.39 169.778C172.54 152.868 203.7 135.978 234.85 119.068C214.17 86.0085 193.51 52.9284 172.82 19.8684C141.59 33.6884 110.35 47.5085 79.1199 61.3285C57.9599 73.1885 36.7899 85.0184 15.6299 96.8784Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6299 96.8784L32.7599 105.088L79.1199 79.7685L125.48 161.218L141.39 169.778L79.1199 61.3385L15.6299 96.8885V96.8784Z",
    fill: "#72D09A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_1423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white",
    transform: "translate(0.23999 0.523438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaison);
export default __webpack_public_path__ + "static/media/maison.f69a526d5607ae059c9b73578c2cbf84.svg";
export { ForwardRef as ReactComponent };